/**
 * Deterministic JSON with recursively-sorted object keys. `brandAssets` is persisted in a Postgres
 * `jsonb` column, which reorders object keys on round-trip — so comparing the raw `JSON.stringify`
 * of a locally-built object (JS insertion order) against the re-fetched value would read as "dirty"
 * forever after a save (or on a fresh workspace / a newly-added color). Sorting keys makes the
 * dirty check order-insensitive. Mirrors JSON semantics: undefined object values are dropped,
 * undefined array items serialize as null.
 *
 * Copied from components/workspace/EditWorkspaceForm.tsx (the old page keeps its own copy, untouched).
 */
export function stableStringify(value: unknown): string {
  if (Array.isArray(value)) {
    return `[${value.map((v) => stableStringify(v)).join(',')}]`;
  }
  if (value && typeof value === 'object') {
    const obj = value as Record<string, unknown>;
    const keys = Object.keys(obj)
      .filter((k) => obj[k] !== undefined)
      .sort();
    return `{${keys.map((k) => `${JSON.stringify(k)}:${stableStringify(obj[k])}`).join(',')}}`;
  }
  return JSON.stringify(value) ?? 'null';
}
